var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('v-card-text',[_vm._v(" Please stand by "),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"white"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }